export const STATUS_PLANNED = 'planned';
export const STATUS_INCOMMING = 'in coming'; 
export const STATUS_ONGOING = 'on going';
export const STATUS_COMPLETED = 'completed';
export const STATUS_ONHOLD = 'on hold';
export const STATUS_CANCELLED = 'cancelled';